import { Location } from '@angular/common';
import { Component, DestroyRef, EventEmitter, inject, OnInit, Output, ViewChild } from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { NgForm } from '@angular/forms';
import { ActivatedRoute } from '@angular/router';
import { AgentRequestACallModel } from '../../models/borrower-portal/agent-request-a-call.model';
import { BasePortalService } from '../../services/base-portal.service';
import { NotificationService } from '../../services/notification.service';
import { TranslocoService } from '@jsverse/transloco';

declare const Swal: any;

@Component({
    selector: 'portal-request-a-call',
    templateUrl: './borrower-portal-request-a-call.component.html',
    styleUrls: ['./borrower-portal-request-a-call.component.scss'],
    standalone: false
})
export class PortalRequestACallComponent implements OnInit {

  @ViewChild('requestCallForm') requestCallForm: NgForm | undefined;

  @Output() close: EventEmitter<boolean> = new EventEmitter<boolean>();

  loanId: number;
  requestACall: AgentRequestACallModel;

  private readonly _destroyRef = inject(DestroyRef);

  constructor(
    private readonly _portalService: BasePortalService,
    private readonly _notificationService: NotificationService,
    private location: Location,
    private readonly _route: ActivatedRoute,
    private readonly _translocoService: TranslocoService
  ) { }

  ngOnInit(): void {
    this._route.queryParams
      .pipe(takeUntilDestroyed(this._destroyRef))
      .subscribe((params) => {
        this.loanId = +params['loanId'];
        this.requestACall = new AgentRequestACallModel(this.loanId);
      });
  }

  bestCallbackTimeChanged = (date: string) => {
    this.requestACall.bestCallbackTime = date;
  }

  submit = () => {
    this.requestCallForm.form.markAllAsTouched();
    if (this.requestCallForm.form.valid) {
      this._portalService.postReqestACall(this.requestACall)
        .subscribe({
          next: () => {
            Swal.fire(
              this._translocoService.translate('common.success'),
              this._translocoService.translate('requestACall.submitSuccessMessage'),
              'success'
            ).then(() => {
              this.close.emit();
              this.location.back();
            });
          },
          error: (err) => {
            this._notificationService.showError(
              err?.error?.message || this._translocoService.translate('requestACall.submitErrorMessage'),
              this._translocoService.translate('common.error')
            );
          }
        });
    }
  }

}
